import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import cloneDeep from 'lodash/cloneDeep';
import { getEmptyImage } from 'react-dnd-html5-backend';
import InfoBox from '../../common/EnhancedGridFeature/InfoBox';
import MenuIcon from '../ACShared/MenuIcon';
import AC_GRID from '../AutocodeTypes';
import { useACGridContext } from '../ACContext/ACGridContext';
import * as MenuTypesOptions from '../../common/MenuTypesOptions';
import {
  COLUMNS_DATA_GRID,
  ROWS_DATA_GRID,
  BASES_DATA_GRID,
} from '../AutocodeConstants';
import ACGridMenuItems from './ACGridMenu/ACGridMenuItems';
import GenericEditWithCancelSave from '../../common/GenericEditWithCancelSave';
import { getLabel } from '../../../util/autocodeUtils';
// import { combineAllChildren } from '../AutocodeFunctions';
/* the following below code will be fetched from redux after mvp */

const source = {
  beginDrag(props) {
    const selectedNodes = [];
    // array created manually
    // selectedNodes.push(props.rowData);
    selectedNodes.push(...props.getSelectedEntries());
    return {
      gridCategory: props.gridCategory,
      selectedNodes,
      gridarray: props.gridarray,
    };
  },
  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      setTimeout(() => {props.clearSelections()}, 100);
    }
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});

const AutocodeGridBodyRow = props => {
  const {
    rowData,
    connectDragSource,
    // isDragging,
    columns,
    gridCategory,
    setCheckBlur,
    partsToShow,
  } = props;

  const label = getLabel(rowData, partsToShow);
  const [inputText, setInputText] = useState({});
  const [dropPanels, setDropPanels] = useState([]);
  const [editing, setEditing] = useState(false);
  const infoBoxRef = useRef(null);

  const { handleContextMenuOptions, handleOnSelectRow } = useACGridContext();
  const {
    EDIT_ROW,
    EDIT_COLUMNS,
    EDIT_BASES,
    EDIT_EXPRESSION,
    DELETE_LABEL,
  } = MenuTypesOptions.CONTEXT_MENU_OPTIONS;

  const saveInput = textValue => {
    setEditing(false);
    const option =
      gridCategory === COLUMNS_DATA_GRID
        ? EDIT_COLUMNS
        : gridCategory === ROWS_DATA_GRID
        ? EDIT_ROW
        : EDIT_BASES;
    const row = cloneDeep(rowData);
    row.updated = { title: textValue };
    handleContextMenuOptions({ option, data: row });
  };

  const handleDropdownClick = label => {
    switch (label) {
      case 'Edit Name': {
        setEditing(true);
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case 'Edit Expression': {
        handleContextMenuOptions({
          option: EDIT_EXPRESSION,
          data: rowData,
          gridCategory,
        });
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case 'Delete': {
        handleContextMenuOptions({
          option: DELETE_LABEL,
          data: rowData,
          gridCategory,
        });
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      default:
        break;
    }
  };

  const buildInfoBox = () => {
    if (dropPanels.length === 0) {
      const ibp = [];
      const style = {
        color: '#eb5757',
      };
      ibp.push(
        <ACGridMenuItems
          element="button"
          label="Edit Name"
          onElemClick={() => handleDropdownClick('Edit Name')}
        />
      );
      ibp.push(
        <ACGridMenuItems
          element="button"
          label="Edit Expression"
          onElemClick={() => handleDropdownClick('Edit Expression')}
        />
      );
      ibp.push(
        <ACGridMenuItems
          element="button"
          label="Delete"
          style={style}
          onElemClick={() => handleDropdownClick('Delete')}
        />
      );
      setDropPanels(ibp);
    }
    return dropPanels;
  };

  useEffect(() => {
    props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }, []);

  useEffect(() => {
    if (editing) {
      inputText.focus();
      inputText.select();
    }
  }, [inputText]);

  return connectDragSource(
    <div
      className="grid-body"
      // style={{
      //   opacity: isDragging ? 0.5 : 1,
      // }}
      data-test="AutocodeGridBodyRow"
      onMouseOver={e => props.handleRowMouseDown(rowData.id, gridCategory, e)}
      onClick={e => {
        if (rowData.id) {
          handleOnSelectRow(rowData.id, gridCategory, e);
        }
      }}
    >
      {editing ? (
        <GenericEditWithCancelSave
          setEditing={setEditing}
          initValue={label}
          saveInput={textValue => saveInput(textValue)}
          setInputText={setInputText}
        />
      ) : (
        <Fragment>
          <div className="grid-row">
            {gridCategory !== BASES_DATA_GRID || rowData.type === 'user' ? (
              <span
                title={label}
                onDoubleClick={() => setEditing(true)}
                className="ac-rp-editable-text report-text"
              >
                {label}
              </span>
            ) : (
              <span className="report-text" title={label}>
                {label}
              </span>
            )}
          </div>
          {columns > 2 ? (
            <Fragment>
              <div className="grid-row">
                <span className="report-sample">
                  {rowData && rowData.sample ? rowData.sample : ' '}
                </span>
              </div>
              <div className="grid-row">
                <span className="report-weighted">
                  {rowData && rowData.weighted ? rowData.weighted : ' '}
                </span>
              </div>
            </Fragment>
          ) : (
            ''
          )}
          <div className="grid-body-icon">
            {rowData && rowData.originalTitle && (
              <span className="view-right-content-drop">
                <InfoBox
                  ref={infoBoxRef}
                  Panels={buildInfoBox()}
                  updatePanels={buildInfoBox}
                  Positions={['bottom']}
                  InfoBoxButtonInner={<MenuIcon fill="black" />}
                  Align="end"
                  containerClassName="ib-popover-dd-container"
                  setCheckBlur={setCheckBlur}
                />
              </span>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

AutocodeGridBodyRow.propTypes = {
  rowData: PropTypes.shape({}),
  columns: PropTypes.number,
  setCheckBlur: PropTypes.func,
};

export default dragSource(
  AC_GRID.AC_GRID_1,
  source,
  collect
)(AutocodeGridBodyRow);
